<template>
  <div class="form-wrapper font">
    <main class="form-signin shadow-lg">
      <div class="text-center px-4">
        <div>
          <a href="/">
            <img src="../assets/img/logo.png" alt="" class="img-fluid" />
          </a>
        </div>
      </div>

      <h3 class="h3 mb-4 mt-4 text-center">
        <u>Conditions d'utilisation de PREFEREPLUS</u>
      </h3>

      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col">
            <p>L'accès à ce site Web, y compris ses sous-domaines, sites associés, applications mobiles et extranets
              (individuellement un « Site » et collectivement les « Sites ») et leur utilisation constituent une
              acceptation de votre part ou de l’entité que vous représentez des conditions d’utilisation présentées
              ci-après (les « Conditions d’utilisation »).</p>

            <p>Si vous n’acceptez pas ces Conditions d’utilisation, il est possible que vous ne puissiez pas accéder
              aux Sites ou les utiliser. D’autres conditions (y compris concernant l’âge minimum) (les « Conditions
              particulières ») peuvent s’appliquer et régir l’accès et l’utilisation de Contenus ou de Fonctionnalités
              de Sites spécifiques (tels que définis ci-dessous).</p><br>

            <h4>Copyright © PREFEREPLUS</h4>
            

            <h4>Contactez-nous</h4>

            <p>Pour toutes questions ou préoccupations concernant les Conditions d’utilisation ou la
              politique de confidentialité, veuillez <a href="/contact">nous
                contacter</a>.</p>
            
          </div>
        </div>
      </div>

      <div class="text-center fs-6 mt-4">
        <p class="mb-1 text-muted">
          &copy; PREFEREPLUS - 2023–<span id="currentYear">2024</span>
        </p>
        <div class="mb-3 text-muted">
          <ul class="list-inline">
            <li class="list-inline-item">
              <router-link to="/register">Inscription</router-link>
            </li>
            <li class="list-inline-item">
              <router-link to="/login">Connexion</router-link>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "CGU",
  inject: ["currentYearUrl"],
  components: {},
  mounted() {
    document.querySelector("body").style.backgroundColor = "#2596be";
    fetch(this.currentYearUrl)
      .then((result) => {
        result.text().then(function (text) {
          document.getElementById("currentYear").textContent = text;
        });
      })
      .catch(() => {
        document.getElementById("currentYear").textContent = "2025";
      });
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  /* background-image: var(--bs-gradient)!important; */
  background-color: #2596be !important;
  font-size: 20px;
}

.styled-list ul {
  list-style-type: none;
}

.styled-list li::before {
  content: "-";
  margin-right: 5px;
}

/* .font{
  font-family: 'proxima-nova', sans-serif;
} */

@media (min-width: 768px) {
  .form-control {
    line-height: 2.5;
  }
}

.btn-group-lg>.btn,
.btn-lg {
  padding: 0.5rem 1.5rem !important;
  font-weight: bold !important;
}

.form-wrapper {
  width: 100%;
  padding: 15px;
  max-width: 800px;
  margin: auto;
  margin-top: 11vh;
  margin-bottom: 8vh;
}

@media (max-width: 575.98px) {
  .form-wrapper {
    margin-top: 7.5vh !important;
    margin-bottom: 4vh !important;
  }

  .form-signin {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}

.form-signin {
  padding: 15px;
  width: 100%;
  background: white;
  border-radius: 8px;
}

.col p {
  text-align: justify;
}
</style>
